import api from './api';

export const landingService = {
  // Obtener datos de la landing pública por slug
  getLanding: async (slug) => {
    const response = await api.get(`/landing/${slug}`);
    return response.data;
  },

  // Procesar inscripción desde la landing
  subscribe: async (slug, formData) => {
    const response = await api.post(`/landing/${slug}/subscribe`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Obtener configuración de landing (autenticado)
  getConfig: async (clubId) => {
    const response = await api.get(`/clubs/${clubId}/landing-config`);
    return response.data;
  },

  // Actualizar configuración de landing (autenticado)
  updateConfig: async (clubId, configData) => {
    const response = await api.put(`/clubs/${clubId}/landing-config`, configData);
    return response.data;
  },

  // Actualizar slug del club (autenticado)
  updateSlug: async (clubId, slug) => {
    const response = await api.put(`/clubs/${clubId}/slug`, { slug });
    return response.data;
  }
};
